import { callApi } from "./ApiClient";

const getSalesforceDescribe = (sobject_name, dispatch) => {
  return callApi(
    "GET",
    `/oauth2/salesforce/describe/${sobject_name}`,
    null,
    dispatch
  );
};

const getSalesforcePreview = (sobject_name, data, dispatch) => {
  return callApi(
    "GET",
    `/oauth2/salesforce/preview/${sobject_name}`,
    data,
    dispatch
  );
};

const getSalesforceImportMappings = (dispatch) => {
  return callApi("GET", `/salesforce_import_mappings`, null, dispatch);
};

const getSalesforceUserinfo = (dispatch) => {
  return callApi("GET", `/oauth2/salesforce/userInfo`, null, dispatch);
};

const postSalesforceRevoke = (data, dispatch) => {
  return callApi("POST", `/oauth2/salesforce/revoke`, data, dispatch);
};

const postSalesforceSync = (data, dispatch) => {
  return callApi("POST", `/oauth2/salesforce/sync`, data, dispatch);
};

const postSalesforceConfig = (data, dispatch) => {
  return callApi("POST", `/oauth2/salesforce/config`, data, dispatch);
};

const getSalesforceConfig = (data, dispatch) => {
  return callApi("GET", `/oauth2/salesforce/config`, data, dispatch);
};

const getSalesforceSyncLastUpdate = (data, dispatch) => {
  return callApi("GET", `/oauth2/salesforce/sync/last_update`, data, dispatch);
};

const getSalesforceListviews = (sobject_name, dispatch) => {
  return callApi(
    "GET",
    `/oauth2/salesforce/listviews/${sobject_name}`,
    null,
    dispatch
  );
};

const postSalesforceExportMappingsExe = (data, dispatch) => {
  return callApi("POST", `/salesforce_export_mappings/exe`, data, dispatch);
};

const postSalesforceExportMappingsTimelineStatus = (data, dispatch) => {
  return callApi("POST", `/salesforce_export_mappings/timeline_status`, data, dispatch);
};

const getSalesforceExportMappings = (data, dispatch) => {
  return callApi("GET", `/salesforce_export_mappings`, data, dispatch);
};

const getSalesforceImportHistories = (data, dispatch) => {
  return callApi("GET", `/salesforce_import_histories`, data, dispatch);
};

const getSalesforceImportHistoriesById = (id, dispatch) => {
  return callApi("GET", `/salesforce_import_histories/${id}`, null, dispatch);
};

const getSalesforceExportHistories = (data, dispatch) => {
  return callApi("GET", `/salesforce_export_histories`, data, dispatch);
};

const getSalesforceExportHistoriesById = (id, dispatch) => {
  return callApi("GET", `/salesforce_export_histories/${id}`, null, dispatch);
};

export const SalesforceApi = {
  getSalesforceDescribe,
  getSalesforcePreview,
  getSalesforceImportMappings,
  getSalesforceUserinfo,
  postSalesforceRevoke,
  getSalesforceSyncLastUpdate,
  postSalesforceSync,
  getSalesforceListviews,
  postSalesforceConfig,
  getSalesforceConfig,
  postSalesforceExportMappingsExe,
  postSalesforceExportMappingsTimelineStatus,
  getSalesforceExportMappings,
  getSalesforceImportHistories,
  getSalesforceImportHistoriesById,
  getSalesforceExportHistories,
  getSalesforceExportHistoriesById,
};



// WEBPACK FOOTER //
// ./src/redux/api/SalesforceApi.js